import { TypeSelectOption } from '@thefarmersfront/kitchen';

/**
 * [입고관리] 센터 별 온도대 필터옵션 객체를 반환하는 함수
 */
const groupTemperatureByCenter = (
  clusters: {
    clusterCode: string | null;
    clusterName: string;
  }[],
  warehouses: {
    warehouseCode: string | null;
    warehouseName: string;
    clusterCode: string;
  }[]
): {
  [key: string]: TypeSelectOption<string>[];
} => {
  const obj = {} as { [key: string]: TypeSelectOption<string>[] };

  clusters.forEach(({ clusterCode }) => {
    if (!clusterCode) return;

    obj[clusterCode] = warehouses
      .filter((warehouse) => warehouse.clusterCode === clusterCode)
      .map((item) => ({ value: item.warehouseCode ?? '', text: item.warehouseName }));
  });

  return obj;
};

export default groupTemperatureByCenter;
